/*
 * iLOLA silent geo redirect (Oct 7, 2026)
 * Sends a visitor to the store for the country they are in (Canada -> /en-ca/,
 * UK -> /en-gb/, Australia/NZ -> /en-au/, everyone else stays where they are),
 * with no popup. Country comes from Shopify's own IP lookup
 * (/browsing_context_suggestions.json -> detected_values.country), the same
 * lookup Shopify's geolocation apps use. The list of country -> store URLs comes
 * from Shopify Markets (window.iLOLA_marketMap, written by
 * snippets/ilola-customer-state.liquid), so a new market needs no code change.
 *
 * Rules:
 *  - Decides once per browser session (sessionStorage), so there are no redirect loops
 *    and later pages in the visit are never delayed.
 *  - If the visitor picked a country in the footer selector, that choice is respected
 *    for as long as they are still detected in the same country. If they travel to a
 *    new country, the saved choice is ignored and they are sent to the local store
 *    (and can switch back with the footer selector, which is then remembered).
 *  - Skipped for: search engines and other bots, wholesale (B2B) customers, the theme
 *    editor, cart / checkout / account pages, and URLs ending in geo=off.
 *  - Page is hidden for at most 0.8s while the country is looked up, so there is no
 *    flash of the wrong store.
 * To remove: delete the <script> lines for this file and for iLOLA_marketMap in
 * snippets/ilola-customer-state.liquid.
 */
(function () {
  if (window.__ilolaGeo) return;
  window.__ilolaGeo = true;

  var ua = navigator.userAgent || '';
  if (/bot|crawl|spider|slurp|lighthouse|pagespeed|headless|facebookexternalhit|embedly|whatsapp|telegram/i.test(ua)) return;

  function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function lget(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lset(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  // Remember a manual choice made in the footer country selector (works on every page).
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest && ev.target.closest('localization-form a[data-value]');
    if (!a) return;
    var picked = a.getAttribute('data-value');
    if (!picked) return;
    lset('ilola_geo_pref', JSON.stringify({ c: picked, d: sget('ilola_geo_d') || '' }));
  }, true);

  // Reasons not to redirect at all.
  try { if (window.Shopify && Shopify.designMode) return; } catch (e) {}
  if (/[?&]geo=off(&|$)/.test(location.search)) return;
  if (/^\/([a-z]{2}-[a-z]{2}\/)?(cart|checkout|checkouts|account|customer_authentication|challenge|password|apps)(\/|$)/i.test(location.pathname)) return;
  try { if (window.iLOLA_customerState && window.iLOLA_customerState.b2b) return; } catch (e) {}
  if (sget('ilola_geo_done')) return;
  var map = window.iLOLA_marketMap;
  if (!map) return;

  var root = '/';
  try { root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; } catch (e) {}
  var curRoot = root.replace(/\/$/, '');
  var curCountry = '';
  try { curCountry = (window.Shopify && Shopify.country) || ''; } catch (e) {}

  var root_el = document.documentElement;
  var style = null;
  try {
    style = document.createElement('style');
    style.textContent = 'html.ilola-geo-hold body{visibility:hidden!important}';
    (document.head || root_el).appendChild(style);
    root_el.classList.add('ilola-geo-hold');
  } catch (e) {}
  function release() {
    try { root_el.classList.remove('ilola-geo-hold'); } catch (e) {}
  }
  var expired = false;
  var failsafe = setTimeout(function () { expired = true; sset('ilola_geo_done', '1'); release(); }, 800);
  function finish() { clearTimeout(failsafe); sset('ilola_geo_done', '1'); release(); }

  var q = '/browsing_context_suggestions.json?country[handle]=' + encodeURIComponent(curCountry || 'US') + '&language[handle]=EN';
  fetch(q, { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (j) {
      if (expired) return;
      var d = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
      if (!d) return finish();
      sset('ilola_geo_d', d);
      if (curCountry && curCountry === d) return finish();      // already on this country's store
      var target = map[d];
      if (typeof target !== 'string') return finish();          // we do not sell to / have no store for this country
      target = target.replace(/\/$/, '');
      if (target === curRoot) return finish();                  // same store (e.g. another language)
      var pref = null;
      try { pref = JSON.parse(lget('ilola_geo_pref') || 'null'); } catch (e) {}
      if (pref && pref.d && pref.d === d) return finish();      // they chose a store while in this same country
      var path = location.pathname;
      if (curRoot && (path === curRoot || path.indexOf(curRoot + '/') === 0)) path = path.slice(curRoot.length) || '/';
      var dest = target + (path === '/' && target ? '/' : path) + location.search + location.hash;
      sset('ilola_geo_done', '1');
      clearTimeout(failsafe);
      location.replace(dest);
    })
    .catch(function () { finish(); });
})();
